export default __webpack_public_path__ + "static/media/g2019-2.633eff36.jpeg";